import React from 'react';
import useAmplitude from 'utils/hooks/useAmplitude';
import useTranslation from 'utils/hooks/useTranslation';
import { Button, Typography } from 'antd';
import { ROUTE_CREDIT_ACCOUNT } from 'constants.js';
import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';
import { useHistory } from 'react-router-dom';
import { CREDIT_ACCOUNT_FAQ_LINK } from 'constants/creditAccount.js';

import styles from './style.module.scss';

const ReplacePaymentsBanner = () => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();
  const history = useHistory();

  const handlePageChange = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.creditAccountsSetUpButtonClicked, {
      source: 'payment methods page',
    });
    history.push(ROUTE_CREDIT_ACCOUNT);
  };

  return (
    <div className={styles.replacePaymentsBannerContainer}>
      <section className={styles.replacePaymentsBannerSection}>
        <Typography className={styles.replacePaymentsBannerTitle}>
          {translateText('corporateAccounts.payments.creditAccountBanner.title')}
        </Typography>
        <Typography>
          {translateText('corporateAccounts.payments.creditAccountBanner.description')}{' '}
          <a href={CREDIT_ACCOUNT_FAQ_LINK} target="_blank" rel="noreferrer">
            {translateText('corporateAccounts.payments.creditAccountBanner.description.cta')}
          </a>
        </Typography>
        <Button
          type="primary"
          className={styles.replacePaymentsBannerButton}
          onClick={handlePageChange}
        >
          {translateText('corporateAccounts.payments.creditAccountBanner.button.cta')}
        </Button>
      </section>
    </div>
  );
};

export default ReplacePaymentsBanner;
